// extracted by mini-css-extract-plugin
module.exports = {"box":"help_box__5F5dF","img":"help_img__2to3k","root":"help_root__1lfXm","anchor":"help_anchor__1FbnT","link":"help_link__3jpw2"};